import { DisclaimerType as DiscType, DisclaimerTypeHelper } from "../../const";
import DisclaimerModal from "./DisclaimerModal";
import IntlMessages from "components/Message/IntlMessages";
import DangerousMessage from "components/Message/DangerousMessage";
import { Button, Checkbox, Form, Space, message, Tooltip } from "antd";
import Upload from "./Upload";
import { shouldUpdate } from "utils/common-util";
import compact from "lodash/compact";
import { ProductAPI } from "services/product";
import { createError } from "utils/error-util";
import classNames from "classnames";
import { openSubModal } from "redux/reducers/central-modal";

export const renderSpecialUhnwModal = ({ dispatch, intl, code, modalProps }) => {
  const renderChioces = (choiceNodes, messageId) => (
    <>
      <div className="mb-2 h5">
        <IntlMessages id={messageId} />
      </div>
      {choiceNodes}
    </>
  );

  const documentsKey = "documents";
  const affirmUhnwWithoutEvidenceKey = DiscType.AFFIRM_UHNW_WITHOUT_EVIDENCE;

  const renderUploadUhnwDocs = (form, isSpecial) => {
    const maxFiles = 10;

    const uploadProps = {
      onRemove: (file) => {
        form.setFieldsValue({
          [documentsKey]: form.getFieldValue(documentsKey).filter((item) => item.uid !== file.uid),
        });
      },
      beforeUpload: async (file) => {
        let documents = form.getFieldValue(documentsKey) ?? [];
        file.isFile = true; // foe check at saga

        // // replace dupliacate by name
        // const uploadedFile = documents.filter((doc) => doc.name === file.name);
        // if (uploadedFile.length) {
        //   documents = documents.filter((doc) => doc.name !== file.name);
        //   form.setFieldsValue({ [documentsKey]: documents });
        // }

        try {
          form.setFieldsValue({
            countValidating: (form.getFieldValue("countValidating") ?? 0) + 1,
          });

          // validate type type [ JPG, JPEG, TIFF, TIF, PNG, PDF, GIF ]
          const fileTypes = ["image/jpeg", "image/png", "image/gif", "application/pdf", "image/tiff"];
          if (!fileTypes.includes(file.type)) {
            const invalidMsg = String(intl.formatMessage({ id: "global.upload.file-type.invalid" }));
            throw createError(invalidMsg);
          }

          // must less than or equals 10MB
          if (file.size > 10 * 1024 * 1024) {
            const invalidMsg = String(intl.formatMessage({ id: "global.upload.file-size-limit" }, { limitMB: 10 }));
            throw createError(invalidMsg);
          }

          const formData = new FormData();
          formData.append("file", file);
          await ProductAPI.validateDocument(formData);
        } catch (error) {
          const _error =
            error.modalMessage ?? error.message ?? String(intl.formatMessage({ id: "global.error.header" }));
          file.status = "error";
          file.response = _error;
          message.error(_error);
        } finally {
          form.setFieldsValue({
            countValidating: (form.getFieldValue("countValidating") ?? 0) - 1,
          });
        }

        form.setFieldsValue({
          [documentsKey]: [...documents, file],
        });

        return false;
      },
    };

    return (
      <>
        <Form.Item noStyle shouldUpdate={shouldUpdate(affirmUhnwWithoutEvidenceKey)}>
          {({ getFieldValue }) => {
            const hidden = getFieldValue(affirmUhnwWithoutEvidenceKey);
            const disabled = (getFieldValue(documentsKey) ?? []).length >= maxFiles;
            return (
              <Form.Item
                className={classNames("input-item-upload position-relative", { "hide-item": hidden })}
                style={{ marginBottom: hidden ? 0 : 12 }}
                label={
                  <div>
                    <Space>
                      <IntlMessages id={isSpecial ? "global.document-special-uhnw" : "global.document-uhnw"} />
                      <Tooltip
                        placement="topRight"
                        arrowPointAtCenter
                        overlayStyle={{ maxWidth: "min(280px, 80dvw)" }}
                        className="color-primary"
                        title={
                          <div>
                            <div className="my-2">
                              <IntlMessages
                                id="global.upload.limitation"
                                values={{ limitMB: 10, limitFiles: 10, prefix: "• " }}
                              />
                            </div>
                            <div className="my-2">
                              <IntlMessages
                                id="global.upload.support-file-type"
                                values={{ supportFileType: "JPG , JPEG , TIFF , TIF , PNG , PDF , GIF", prefix: "• " }}
                              />
                            </div>
                          </div>
                        }
                        trigger={["click"]}
                        onClick={(evt) => evt.stopPropagation()}
                        getPopupContainer={() => document.querySelector(".input-item-upload")}
                      >
                        <span className="icon-alert-main text-white" style={{ width: 20, height: 20 }}>
                          ?
                        </span>
                      </Tooltip>
                    </Space>
                  </div>
                }
                name={documentsKey}
                valuePropName="fileList"
                getValueFromEvent={(...args) => args[0]?.fileList}
              >
                <Upload
                  {...uploadProps}
                  accept=".jpg,.jpeg,.pdf,.gif,.tif,.tiff,.png"
                  maxCount={maxFiles}
                  showFileCount
                  multiple
                  hidden={hidden}
                  disabled={disabled}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item noStyle shouldUpdate={shouldUpdate(documentsKey)}>
          {({ getFieldValue, setFieldsValue }) => {
            const foundUploadFields = !!getFieldValue(documentsKey)?.length;
            const immediatelyDisabledAfterUpload = (getFieldValue("countValidating") ?? 0) > 0;
            return (
              <>
                <Form.Item
                  className="form-with-no-explain"
                  name={affirmUhnwWithoutEvidenceKey}
                  valuePropName="checked"
                  hidden={foundUploadFields}
                >
                  <Checkbox
                    onChange={(evt) => {
                      if (evt.target.checked) {
                        dispatch(
                          openSubModal({
                            code: DisclaimerTypeHelper.ConfirmSelfDeclare,
                            actions: {
                              onCancel: () => form.setFieldsValue({ [affirmUhnwWithoutEvidenceKey]: false }),
                            },
                          })
                        );
                      }
                    }}
                    disabled={immediatelyDisabledAfterUpload}
                  >
                    <span className="user-select-none">
                      <IntlMessages id="global.upload.document.affirm-wihtout-evidence" />
                    </span>
                  </Checkbox>
                </Form.Item>

                {foundUploadFields && (
                  <Button className="mt-2" onClick={() => setFieldsValue({ [documentsKey]: [] })} danger block>
                    <Space>
                      <i className="feather-icon icon-trash" style={{ fontSize: 14 }}></i>
                      <IntlMessages id="global.upload.document.affirm-wihtout-evidence.delete-all" />
                    </Space>
                  </Button>
                )}
              </>
            );
          }}
        </Form.Item>
      </>
    );
  };

  const disabledOkButton = (form) => {
    const accepts = compact([
      ...Object.entries(form.getFieldsValue(true))
        .filter(([field, checked]) => {
          return ![documentsKey, affirmUhnwWithoutEvidenceKey].includes(field) && checked;
        })
        .map(([code]) => code),
    ]);
    const acceptSomeChoice = accepts.length > 0;
    return !acceptSomeChoice;
  };

  const disabledOkButtonAwareDocument = (form) => {
    const didNotAcceptAnyChoice = disabledOkButton(form);
    const values = form.getFieldsValue([documentsKey, affirmUhnwWithoutEvidenceKey, "countValidating"]);
    const documents = values[documentsKey];
    const affirmWithoutEvidence = values[affirmUhnwWithoutEvidenceKey];
    return (
      didNotAcceptAnyChoice ||
      (!affirmWithoutEvidence &&
        (!documents?.length || (values.countValidating ?? 0) > 0 || documents?.some((doc) => doc.status === "error")))
    );
  };

  const customValueOnAccept = (values) => {
    const accepts = compact([
      code,
      ...Object.entries(values)
        .filter(([, checked]) => checked)
        .map(([code]) => code),
    ]);

    return accepts;
  };

  const customValueOnAcceptAwareDocument = (values) => {
    if (values[affirmUhnwWithoutEvidenceKey]) {
      delete values[documentsKey];
    }

    values = compact([
      code,
      ...Object.entries(values)
        .filter(
          ([field, value]) => (typeof value === "boolean" && value) || (field === documentsKey && !!value?.length)
        )
        .map(([field, value]) =>
          field === documentsKey
            ? value?.map((fileInfo) => ({
                ...fileInfo,
                fileUrl: URL.createObjectURL(fileInfo.originFileObj),
              }))
            : field
        ),
    ]);

    return values;
  };

  const loadingOkButtonAwareDocumentValidating = (form) => {
    const countValidating = form.getFieldValue("countValidating") ?? 0;
    return countValidating > 0;
  };

  return [
    // HNWW
    <DisclaimerModal
      {...modalProps}
      key={DiscType.HNW_WEALTH}
      title="modal.disclaimer.header.for-uhnw"
      message={DiscType.HNW_WEALTH}
      choices={[DiscType.HNW_WEALTH_CHOICE_1, DiscType.HNW_WEALTH_CHOICE_2, DiscType.HNW_WEALTH_CHOICE_3]}
      acceptLabel="global.next"
      rejectLabel="global.cancel"
      visible={code === DiscType.HNW_WEALTH}
      renderChioces={(choiceNodes) => renderChioces(choiceNodes, "global.product-uhnw.wealth")}
      customValueOnAccept={customValueOnAccept}
      disabledOkButton={disabledOkButton}
    />,
    // HNWE
    <DisclaimerModal
      {...modalProps}
      key={DiscType.HNW_EXPERIENCE}
      title="modal.disclaimer.header.for-uhnw"
      message={DiscType.HNW_EXPERIENCE}
      choices={choicesNewHnwExp}
      acceptLabel="global.confirm"
      rejectLabel="global.back"
      visible={code === DiscType.HNW_EXPERIENCE}
      renderChioces={(choiceNodes) => renderChioces(choiceNodes, "global.product-uhnw.experience")}
      renderContentFooter={(form) => (
        <div>
          {renderUploadUhnwDocs(form, false)}
          <div className="accept-checkbox no-font-size m-0 mt-3">
            <DangerousMessage.Div
              html={intl.formatMessage({
                id: "modal.disclaimer.hnw.experience.remark",
              })}
            />
          </div>
        </div>
      )}
      customValueOnAccept={customValueOnAcceptAwareDocument}
      disabledOkButton={disabledOkButtonAwareDocument}
      loadingOkButton={loadingOkButtonAwareDocumentValidating}
    />,
    // UHNWW
    <DisclaimerModal
      {...modalProps}
      key={DiscType.UHNW_WEALTH}
      title="modal.disclaimer.header.for-uhnw-special"
      message={DiscType.UHNW_WEALTH}
      choices={[DiscType.UHNW_WEALTH_CHOICE_1, DiscType.UHNW_WEALTH_CHOICE_2, DiscType.UHNW_WEALTH_CHOICE_3]}
      acceptLabel="global.next"
      rejectLabel="global.cancel"
      visible={code === DiscType.UHNW_WEALTH}
      renderChioces={(choiceNodes) => renderChioces(choiceNodes, "global.product-uhnw.wealth")}
      customValueOnAccept={customValueOnAccept}
      disabledOkButton={disabledOkButton}
    />,
    // UHNWE
    <DisclaimerModal
      {...modalProps}
      key={DiscType.UHNW_EXPERIENCE}
      title="modal.disclaimer.header.for-uhnw-special"
      message={DiscType.UHNW_EXPERIENCE}
      choices={choicesSpecialUhnwExp}
      acceptLabel="global.confirm"
      rejectLabel="global.back"
      visible={code === DiscType.UHNW_EXPERIENCE}
      renderChioces={(choiceNodes) => renderChioces(choiceNodes, "global.product-uhnw.experience")}
      renderContentFooter={(form) => (
        <div>
          {renderUploadUhnwDocs(form, true)}
          <div className="accept-checkbox no-font-size m-0 mt-3">
            <DangerousMessage.Div
              html={intl.formatMessage({
                id: "modal.disclaimer.hnw.experience.remark",
              })}
            />
          </div>
        </div>
      )}
      customValueOnAccept={customValueOnAcceptAwareDocument}
      disabledOkButton={disabledOkButtonAwareDocument}
      loadingOkButton={loadingOkButtonAwareDocumentValidating}
    />,
  ];
};

const choicesSpecialUhnwExp = [
  DiscType.UHNW_EXPERIENCE_CHOICE_1,
  DiscType.UHNW_EXPERIENCE_CHOICE_2,
  DiscType.UHNW_EXPERIENCE_CHOICE_3,
  DiscType.UHNW_EXPERIENCE_CHOICE_4,
  DiscType.UHNW_EXPERIENCE_CHOICE_5,
];

const choicesNewHnwExp = [
  DiscType.HNW_EXPERIENCE_CHOICE_1,
  DiscType.HNW_EXPERIENCE_CHOICE_2,
  DiscType.HNW_EXPERIENCE_CHOICE_3,
  DiscType.HNW_EXPERIENCE_CHOICE_4,
  DiscType.HNW_EXPERIENCE_CHOICE_5,
];
